import React from 'react';
import styles from './index.module.scss';

const Printer = ({ className }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='45.999'
        height='46'
        viewBox='0 0 45.999 46'
        className={className}
    >
        <g transform='translate(-0.007)'>
            <g transform='translate(0.007)'>
                <rect
                    width='14.374'
                    height='2.876'
                    transform='translate(14.375 34.5)'
                    className={styles.light}
                />
                <path
                    d='M93.86,2.875h23v5.75h2.875V2.875A2.875,2.875,0,0,0,116.859,0h-23a2.876,2.876,0,0,0-2.875,2.875v5.75H93.86Z'
                    transform='translate(-82.36)'
                    className={styles.light}
                />
                <rect
                    width='17.249'
                    height='2.875'
                    transform='translate(14.375 28.75)'
                    className={styles.light}
                />
                <path
                    d='M43.131,121.3H2.882a2.876,2.876,0,0,0-2.875,2.875v17.25A2.874,2.874,0,0,0,2.882,144.3h5.75v8.625a2.874,2.874,0,0,0,2.875,2.875h23a2.873,2.873,0,0,0,2.875-2.875V144.3h5.75a2.873,2.873,0,0,0,2.875-2.875v-17.25A2.875,2.875,0,0,0,43.131,121.3Zm-8.625,31.625h-23v-17.25h23v17.25Zm5.749-23a2.875,2.875,0,1,1,2.876-2.875A2.873,2.873,0,0,1,40.256,129.929Z'
                    transform='translate(-0.007 -109.804)'
                    className={styles.light}
                />
            </g>
        </g>
    </svg>
);

export default Printer;
